export enum UserRole {
  admin = 'admin',
  viewer = 'viewer',
  editor = 'editor',
  student = 'student',
  teacher = 'teacher',
  collaborator = 'collaborator',
}
